import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const stepper = ["事前確認", "提出内容確認", "掛金の確認", "機構へ提出"];

const headList = [
  {
    headTitle: (
      <>
        施設名称
        <TkHelpIcon
          helpMessage={
            <>
              掛金納付対象職員届の対象となる施設等の名称です。
              <br />
              契約対象となる施設等がすべて表示されていることを確認してください。
              <br />
              ※新たに新設・申出した施設等も含みます。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        開始年月日
        <TkHelpIcon helpMessage="施設区分が「社会福祉施設等」の場合は、事業開設年月日、「特定介護保険施設」、「申出施設等」の場合は申出日が開設年月日となります。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        施設住所
        <TkHelpIcon helpMessage="現在登録されている施設等の所在地です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        施設種類
        <TkHelpIcon helpMessage="現在登録されている施設等の施設種類・サービス種類です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        施設区分
        <TkHelpIcon
          helpMessage={
            <>
              施設種類・サービス種類に応じた施設区分を表示しています。
              <br />
              施設区分に応じて掛金が変わります。
              <br />
              詳しくは
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫施設区分について.pdf`}
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        特定職員数等
        <TkHelpIcon
          helpMessage={
            <>
              「特定介護保険施設等」については、特定職員数または措置入所障害児関係業務従事職員数の人数分については、公費補助の対象となります。詳しくは、特定職員数は
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫特定職員数について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              を、措置入所障害児関係業務従事職員数については、
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫措置入所障害児関係業務従事職員数について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        非加入届
        <TkHelpIcon helpMessage="制度改正時点または施設の転換日時点で掛金が「単位掛金額×３」となる職員は加入させない手続きを行った施設・事業は「有」となっています。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        部分解除
        <TkHelpIcon helpMessage="制度改正以後または施設の転換日以後で掛金が「単位掛金額×３」となる職員を解除し、今後加入させない手続きを行った施設・事業は「有」となっています。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        担当者情報
        <TkHelpIcon helpMessage="施設情報や当該施設に係る加入職員について確認事項がある場合に、当機構より照会させていただく際の担当者様及び担当者様電話番号を表示しています。" />
      </>
    ),
  },
];

export { stepper, headList };
